{
  "changeCurrency": "更改顯示貨幣",
  "approx": "≈ {value}",
  "disclaimer": "換算價格僅供參考，所有競投及付款均以英鎊（GBP）結算。",
  "currencies": {
    "gbp": "英鎊",
    "hkd": "港元",
    "jpy": "日圓",
    "usd": "美元",
    "eur": "歐元"
  }
}
